import http from "@/http/aisea/axios";
const resource = "/enterprises/crews/fiscal_year_defaults";

/**
 * 年度設定マスタAPI
 */
export default {
  /**
   * 年度設定マスタ取得
   */
  fetch() {
    return http.get(`${resource}`);
  },
};
